import React, { createContext, useState } from "react";

// Create the Context
export const ModeContext = createContext();

const default_mode = "default";

// Provider component
export const ModeProvider = ({ children }) => {
  const [mode, setMode] = useState(default_mode); // Default mode

  const changeMode = (newMode) => {
    //Handles converting Display Names to actual values
    switch (newMode) {
      case "Light Mode":
        setMode("light");
        break;
      case "Dark Mode":
        setMode("dark");
        break;
      case "Accent Mode":
        setMode("accent");
        break;
      default:
        setMode(default_mode);
    }
  };

  return (
    <ModeContext.Provider value={{ mode, changeMode }}>
      {children}
    </ModeContext.Provider>
  );
};
